/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/media_library_sources" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { mediaLibrarySourcesCacheKey } from "./constants";
import type { MediaLibrarySourcesResult } from "./types";
import { isMediaLibrarySourcesResult } from "./validators";

export const getMediaLibrarySources = reactQueryFetcherAdapter(
  mediaLibrarySourcesCacheKey,
  (signal: AbortSignal, appGroupId: string): Promise<MediaLibrarySourcesResult> => {
    return fetch(
      `/engagement/${appGroupId}/media_library_sources`,
      "GET",
      {
        app_group_id: appGroupId,
      },
      { signal }
    );
  },
  isMediaLibrarySourcesResult
);
